import React from "react";
import styled from "styled-components";
// Components
import PricingTable from "../Elements/PricingTable";

export default function Pricing() {
  return (
    <Wrapper id="pricing">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Nos Programmes</h1>
            <p className="font13">
              Explorez nos différents programmes conçus pour répondre à vos besoins professionnels et personnels.
              <br />
              Apprenez, développez et excellez avec nos formations de qualité.
            </p>
          </HeaderInfo>
          <TablesWrapper className="flexSpaceNull">
            <TableBox>
              <PricingTable
                icon="roller"
                // price="$29,99/mo"
                title="Intelligence Artificielle"
                text="L’Intelligence Artificielle révolutionne tous les secteurs, et il est essentiel d’en comprendre les mécanismes pour en tirer parti. Ce programme avancé vous plonge dans l’univers de l’IA appliquée à travers des outils innovants et des cas pratiques concrets."
                offers={[
                  { name: "Les fondamentaux de l’IA et ses impacts économiques.", cheked: true },
                  { name: "L’utilisation stratégique des outils d’IA générative (ChatGPT, Midjourney, Copilot AI, etc.).", cheked: true },
                  { name: "L’initiation au Machine Learning et Deep Learning.", cheked: true },
                  { name: "L’automatisation et l’optimisation des tâches avec l’IA.", cheked: true },
                  //{ name: "Ressources supplémentaires", cheked: false },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox>
            
            <TableBox>
              <PricingTable
                icon="monitor"
               // price="$49,99/mo"
                title="Analyse de Données Appliquée"
                text="Les données sont devenues le nouveau pétrole de l’économie digitale. Ce programme vous enseigne les outils essentiels pour collecter, analyser et interpréter les données afin d’optimiser la prise de décision."
                offers={[
                  { name: "Les principes fondamentaux de l’analyse de données.", cheked: true },
                  { name: "La manipulation des bases de données avec SQL.", cheked: true },
                  { name: "La visualisation de données et la création de tableaux de bord avec Power BI et Tableau.", cheked: true },
                  { name: "L’exploitation de Python pour des analyses avancées et du Machine Learning.", cheked: true },
                  //{ name: "Des études de cas sectoriels pour une application immédiate.", cheked: true },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox>
            {/* <TableBox>
              <PricingTable
                icon="browser"
               // price="$59,99/mo"
                title="IA & Graphisme"
                text="L’Intelligence Artificielle transforme la manière dont nous concevons et produisons des visuels. Cette formation vous apprend à exploiter l’IA pour booster votre créativité et produire des visuels professionnels en un temps record."
                offers={[
                  { name: "Création assistée par l’IA (DALL·E, Midjourney, Adobe Firefly).", cheked: true },
                  { name: "Génération d’illustrations et d’éléments graphiques.", cheked: true },
                  { name: "Automatisation du design et de la retouche photo.", cheked: true },
                  { name: "Branding visuel et identité graphique avec l’IA.", cheked: true },
                  { name: "Intégration de l’IA dans Photoshop, Canva et d’autres outils.", cheked: true },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox> */}
            {/* <TableBox>
              <PricingTable
                icon="browser"
                // price="$29,99/mo"
                title="Montage Vidéo & IA"
                text="Le contenu vidéo domine le digital. Grâce à l’IA, montez des vidéos rapidement, améliorez la qualité et automatisez certaines tâches pour produire du contenu percutant en un temps record."
                offers={[
                  { name: "Initiation au montage vidéo avec IA (Runway, etc.).", cheked: true },
                  { name: "Génération et retouche automatique de vidéos.", cheked: true },
                  { name: "Sous-titrage et transcription automatique avec IA.", cheked: true },
                  { name: "Animation et effets spéciaux intelligents.", cheked: true },
                  { name: "Automatisation du contenu vidéo pour les réseaux sociaux.", cheked: true },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox> */}
            <TableBox>
              <PricingTable
                icon="browser"
                // price="$29,99/mo"
                title="Social Media Management et IA"
                text="Les réseaux sociaux sont incontournables pour développer une marque. Cette formation vous dote des compétences essentielles pour gérer efficacement les plateformes sociales et maximiser l’engagement de votre audience."
                offers={[
                  { name: "Définir une stratégie social media efficace.", cheked: true },
                  { name: "Création de contenus engageants et optimisés.", cheked: true },
                  { name: "Outils d’automatisation pour une gestion simplifiée.", cheked: true },
                  { name: "Analyse des performances et optimisation des campagnes.", cheked: true },
                  //{ name: "Automatisation du contenu vidéo pour les réseaux sociaux.", cheked: true },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox>
          </TablesWrapper>
        </div>
      </div>
    </Wrapper>
  );
}




const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto
  }
`;
const PricingTitle = styled.h1`
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 20px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;




